<template>
  <div>
    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="16" :md="16">
        <el-input v-model="filtro.nome" placeholder="Pesquisar fornecedor..." @keyup.native.enter="loadingFornecedores"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <router-link to="/admin/financeiro/fornecedor/cadastro" class="btn-new-register">
          <el-button type="primary">NOVO FORNECEDOR</el-button>
        </router-link>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="u-mb-10">
      <el-col :xs="24" :sm="8" :md="8">
        <el-input v-model="filtro.cnpj" placeholder="CNPJ" @keyup.native.enter="loadingFornecedores"></el-input>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8">
        <el-select v-model="filtro.tipo_fornecedor" placeholder="Tipo" clearable>
          <el-option label="AGRICULTURA FAMILIAR" value="agricultura_familiar"></el-option>
          <el-option label="EMPRESA" value="empresa"></el-option>
          <!-- BLOCO Z, item 28 — fornecedores de serviços do transporte escolar. -->
          <el-option label="TRANSPORTE" value="transporte"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8">
        <el-select v-model="filtro.ativo" placeholder="Situação" clearable>
          <el-option label="ATIVO" :value="true"></el-option>
          <el-option label="INATIVO" :value="false"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
        <el-button @click="loadingFornecedores" type="info" plain icon="el-icon-search">FILTRAR</el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Nome</th>
            <th class="hidden-mobile" style="width: 140px;">Tipo</th>
            <th class="hidden-mobile">CNPJ</th>
            <th class="hidden-mobile">Telefone</th>
            <th class="hidden-mobile">Email</th>
            <th class="hidden-mobile u-text-center">Ativo</th>
            <th style="width: 150px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ item.nome }}</td>
            <td class="hidden-mobile">{{ item.tipo_fornecedor ? item.tipo_fornecedor.replace('_', ' ').toUpperCase() : '-' }}</td>
            <td class="hidden-mobile">{{ item.cnpj || '-' }}</td>
            <td class="hidden-mobile">{{ item.telefone || '-' }}</td>
            <td class="hidden-mobile">{{ item.email || '-' }}</td>
            <td class="hidden-mobile u-text-center">{{ item.ativo ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao">
              <router-link :to="'/admin/financeiro/fornecedor/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button @click="deleteFornecedor(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>

      <el-row :gutter="10" v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-text-left u-mt-10">
            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: {
      nome: '',
      cnpj: '',
      tipo_fornecedor: '',
      ativo: ''
    },
    paginate: {
      page: 1,
      qtdItens: null,
      from: '',
      to: ''
    },
    items: []
  }),
  mounted () {
    /*
     * BLOCO Z, item 28 — o menu do Transporte aponta para cá com
     * `?tipo_fornecedor=transporte`. Ler a query é o que torna o atalho um atalho, em vez de
     * um link para a lista inteira. Não existe CRUD de fornecedor dentro do Transporte.
     */
    if (this.$route.query.tipo_fornecedor) {
      this.filtro.tipo_fornecedor = this.$route.query.tipo_fornecedor
    }

    this.loadingFornecedores()
  },
  methods: {
    loadingFornecedores () {
      this.statusList = false
      this.items = []
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    deleteFornecedor (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir este fornecedor?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/delete/` + id, this.$store.getters.getHeaderAuth).then(() => {
            window.eventBus.$emit('loading', false)
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.loadingFornecedores()
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) {
      this.paginate.page = page
      this.loadingFornecedores()
    }
  }
}
</script>

